declare namespace $ {

	export class $exso_sheets extends $mol_object {
		list( ): readonly(any)[]
		value( id: any): string
		paths( ): readonly(string)[]
		columns( ): Record<string, any>
		parse( id: any): any
		hue( id: any): string
		unique( id: any): readonly(any)[]
		order_by( ): readonly(string)[]
		type( ): unknown | null
	}
	
}

//# sourceMappingURL=sheets.view.tree.d.ts.map